import { Layout } from 'antd';
import { isMobile } from 'react-device-detect';
import CustomOrderHeader from '../components/custom/lib/CustomOrderHeader';
import { Content } from 'antd/es/layout/layout';
import { Outlet } from 'react-router-dom';
import CustomOrderFooter from '../components/custom/lib/CustomOrderFooter';

const CustomOrderLayout = () => {
  return (
    <Layout>
      {!isMobile ? <CustomOrderHeader /> : null}
      <Content>
        <Outlet />
      </Content>
      {!isMobile ? <CustomOrderFooter /> : null}
    </Layout>
  );
};

export default CustomOrderLayout;
